var _rect, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _g2, _path8, _g3, _path9, _path0, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNanoclaw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      maxHeight: 500
    },
    viewBox: "102 50 340 396",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "",
    height: 512,
    width: 512
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#121729",
    d: "M312.833 50.3257C313.295 50.0364 313.841 49.9335 314.364 50.0425C314.887 50.1515 315.346 50.4643 315.654 50.914C315.96 51.3634 316.09 51.9132 316.001 52.44C315.744 53.9557 315.463 55.4628 315.157 56.9699C309.651 82.6695 298.819 106.906 283.07 128.66C289.137 133.164 294.321 138.293 298.925 144.008C314.317 122.475 325.542 96.1428 331.654 69.4775C331.982 67.9754 332.29 66.4606 332.574 64.9508C332.673 64.4252 332.984 63.9532 333.428 63.6372C333.872 63.3214 334.412 63.1871 334.941 63.2659C335.47 63.3448 335.948 63.6309 336.28 64.0625C336.612 64.494 336.772 65.0362 336.713 65.5676C336.538 67.1358 336.338 68.7112 336.117 70.275C331.725 98.4831 322.735 125.603 307.331 150.836C306.774 151.655 306.217 152.454 305.595 153.267C308.663 158.001 311.494 163.054 314.211 168.411C322.302 184.349 326.491 201.876 327.83 219.618C327.947 221.11 328.02 226.125 329.127 226.969C331.944 227.213 343.067 212.613 344.855 209.976C346.334 207.795 350.159 201.991 350.831 199.535C353.234 190.729 354.28 181.439 354.966 172.339C356.585 153.905 366.421 136.116 381.285 125.085C387.283 120.629 399.301 113.555 406.244 120.738C412.349 127.056 400.225 133.653 397.971 138.35C396.507 141.403 398.327 144.92 398.865 147.957C399.742 152.921 398.758 156.421 396.76 160.893C396.358 161.792 395.809 162.822 396.322 163.782C399.06 165.8 402.158 158.946 403.303 157.337C406.892 152.261 412.033 149.285 416.789 145.507C417.353 145.059 417.588 144.322 417.443 143.617C416.432 138.673 415.769 128.972 418.231 125.423C426.761 113.118 439.002 125.264 440.868 135.76C442.704 145.758 442.291 155.84 439.745 165.703C434.683 185.31 423.677 203.372 407.391 215.63C401.279 220.231 395.6 222.746 388.532 224.649C387.657 224.884 386.89 225.417 386.37 226.159C367.888 252.505 339.492 271.754 318.835 280.459C313.182 285.694 308.434 292.827 303.055 298.523C302.077 299.559 302.17 301.23 303.374 301.993C305.937 303.618 308.609 304.863 311.285 306.437C327.284 315.842 337.367 330.975 339.793 349.401C341.644 362.448 340.858 375.733 337.48 388.47C354.988 393.873 383.038 422.402 357.476 435.736C339.919 444.514 313.398 443.47 294.423 444.715C254.022 447.151 213.162 445.913 172.787 442.763C168.288 442.444 145.665 441.343 143.583 437.982C143.377 431.957 170.427 431.874 174.93 430.28C172.622 428.724 169.113 427.312 166.527 426.016C162.322 423.874 158.341 421.316 154.643 418.386C149.059 413.974 146.506 410.025 142.322 404.567C141.08 402.945 136.178 400.665 134.264 399.043C121.827 388.542 115.698 371.683 114.099 355.875C113.608 351.025 113.072 351.641 110.481 347.804C98.4767 330.031 100.175 296.48 109.587 278.15C95.0988 229.215 130.463 153.393 171.898 126.17C197.674 109.029 233.236 105.669 262.198 117.172C266.525 118.897 270.516 120.81 274.217 122.906C290.56 103.891 303.524 80.5559 310.751 55.9009C311.159 54.4678 311.543 53.032 311.905 51.5857C312.034 51.0675 312.372 50.6152 312.833 50.3257Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_37_875)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#56EDD6",
    d: "M230.484 331.074C229.028 330.64 228.515 328.803 229.579 327.719C270.928 285.602 325.092 311.07 327.088 353.942C329.176 445.679 210.249 427.094 201.898 425.009C204.701 422.517 212.782 420.746 216.597 413.961C218.671 410.273 222.955 407.031 227.073 408.001C239.826 411.006 259.732 412.776 261.762 400.4C263.134 392.03 253.102 388.482 246.115 383.231C242.318 380.378 244.547 375.859 249.232 376.637C258.804 378.225 270.14 382.499 274.468 373.847C283.285 356.218 250.909 337.166 230.484 331.074Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#56EDD6",
    d: "M195.808 127.951C214.791 119.578 238.598 121.154 257.606 128.077C259.755 128.859 262.182 129.866 264.102 131.312C265.255 132.18 265.472 133.777 264.698 134.995C261.074 140.7 254.656 144.044 251.188 149.751C249.027 153.306 251.453 156.164 254.614 157.786C262.64 161 269.137 148.074 274 141.617C275.015 140.269 276.869 140.029 278.261 140.983C293.726 151.573 303.711 171.55 309.165 188.006C317.462 213.034 322.752 246.519 310.368 271.095C304.717 282.253 298.62 290.646 282.799 294.17C266.623 297.638 246.758 291.335 229.793 310.902C227.703 313.142 225.671 316.045 223.513 318.538C216.338 326.831 206.873 316.511 201.281 307.078C196.582 299.15 190.991 291.501 184.931 289.718C174.743 285.383 166.558 292.078 167.488 304.163C168.418 316.247 160.425 309.79 149.658 303.631C138.892 297.472 124.589 284.832 120.573 269.62C109.081 225.782 150.382 142.7 195.808 127.951Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.71,
    fill: "white",
    d: "M195.808 127.951C206.164 123.383 217.956 121.777 229.621 122.384C221.088 122.841 212.711 124.597 205.107 127.951C159.681 142.7 118.38 225.782 129.872 269.62C133.888 284.832 148.191 297.472 158.958 303.631C162.008 305.376 164.836 307.145 167.301 308.509C165.878 314.257 158.759 308.837 149.658 303.631C138.892 297.472 124.589 284.832 120.573 269.62C109.081 225.782 150.382 142.7 195.808 127.951Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#121729",
    d: "M182.982 181.34C194.083 180.448 203.81 188.709 204.725 199.803C205.64 210.898 197.396 220.639 186.299 221.576C175.169 222.517 165.389 214.247 164.472 203.12C163.554 191.992 171.848 182.234 182.982 181.34Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M189.666 187.732C191.25 187.756 192.654 187.973 194.077 188.707C195.972 189.675 197.384 191.377 197.984 193.414C198.502 195.203 198.246 197.126 197.278 198.718C195.957 200.922 194.007 201.799 191.665 202.446C189.924 202.755 188.313 202.644 186.699 201.854C184.995 201.037 183.722 199.533 183.202 197.72C182.628 195.731 182.885 193.594 183.917 191.797C185.157 189.676 187.31 188.302 189.666 187.732Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#121729",
    d: "M290.376 179.422C302.005 178.488 312.195 187.142 313.153 198.764C314.111 210.387 305.476 220.591 293.851 221.573C282.192 222.558 271.948 213.895 270.987 202.238C270.026 190.581 278.713 180.358 290.376 179.422Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M296.293 184.943C298.02 184.969 299.552 185.2 301.105 185.979C303.172 187.008 304.713 188.817 305.367 190.981C305.932 192.881 305.652 194.924 304.596 196.616C303.155 198.958 301.029 199.89 298.474 200.577C296.574 200.905 294.817 200.787 293.056 199.948C291.197 199.08 289.809 197.482 289.241 195.556C288.614 193.442 288.896 191.172 290.021 189.262C291.374 187.009 293.723 185.549 296.293 184.943Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_37_875)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#56EDD6",
    d: "M163.044 355.456C116.55 362.341 109.811 329.418 113.102 305.622C113.487 302.834 117.531 302.195 119.419 304.282C127.345 313.041 141.133 320.261 152.257 324.522C160.125 327.535 168.635 336.184 170.607 344.375C171.867 349.605 168.365 354.668 163.044 355.456Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#56EDD6",
    d: "M178.775 383.188C143.062 407.16 130.237 385.196 127.663 367.485C127.359 365.389 129.402 363.821 131.435 364.415C149.06 369.557 164.818 369.719 173.396 368.858C175.793 368.617 178.171 369.626 179.349 371.729C179.802 372.538 180.319 373.482 180.896 374.563C182.493 377.558 181.593 381.296 178.775 383.188Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#56EDD6",
    d: "M161.48 403.847C166.757 402.469 171.019 400.856 174.414 399.206C181.588 395.719 191.894 392.63 198.979 396.293C199.629 396.629 200.287 396.981 200.953 397.354C204.905 399.569 206.01 404.739 203.13 408.237C187.83 426.818 167.66 415.654 160.05 407.976C158.623 406.536 159.518 404.359 161.48 403.847Z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#121729",
    d: "M213.07 217.149C214.75 216.52 216.628 216.573 218.329 217.283C220.031 217.992 221.397 219.307 222.291 220.877C222.629 221.355 223.011 221.843 223.429 222.326C228.674 228.503 238.489 231.993 243.281 230.183C245.593 229.514 248.301 228.424 251.766 225.817C252.373 225.36 252.977 224.895 253.621 224.348C254.885 223.159 256.42 222.199 258.138 221.816C259.854 221.433 261.593 221.649 263.052 222.46C264.512 223.271 265.607 224.631 266.177 226.285C266.748 227.939 266.728 229.742 266.371 231.435C266.056 232.591 265.709 233.673 265.256 234.792C262.854 240.994 257.08 247.418 249.017 249.696C230.73 254.233 216.03 243.351 209.857 229.669C209.366 228.491 208.946 227.265 208.622 226.001C208.25 224.235 208.402 222.351 209.21 220.701C210.016 219.052 211.39 217.779 213.07 217.149Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_37_875)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#56EDD6",
    d: "M328.583 407.417C331.371 403.551 335.658 400.7 339.87 402.931C348.266 407.379 357.568 417.274 350.852 424.261C344.934 430.42 318.206 431.086 304.752 430.221C302.871 430.1 302.424 427.814 304.065 426.888C312.083 422.368 322.159 416.321 328.583 407.417Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#56EDD6",
    d: "M193.194 338.351C202.972 334.689 212.42 336.606 222.206 338.171C248.293 342.344 269.164 363.205 266.034 369.464C219.063 358.058 226.584 382.285 244.81 394.555C246.572 395.741 245.88 398.9 243.757 398.846C213.625 398.079 195.352 382.719 187.481 365.283C178.88 346.227 185.232 341.333 193.194 338.351Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#56EDD6",
    d: "M179.12 299.515C186.933 297.121 191.62 317.791 198.784 325.259C199.456 325.959 199.098 327.476 198.144 327.655C193.179 328.583 187.72 330.305 183.507 333.22C181.921 334.317 178.661 333.269 178.32 331.371C176.395 320.644 172.159 301.648 179.12 299.515Z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_37_875)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#56EDD6",
    d: "M355.352 212.125C356.458 210.199 359.208 209.968 360.7 211.614C364.463 215.763 368.155 218.265 372.885 221.01C374.31 221.838 374.82 223.64 373.851 224.972C364.269 238.136 329.399 269.124 326 263.254C327.229 259.048 328.639 253.788 329.283 247.503C329.724 243.202 331.841 239.209 335.176 236.458C344.458 228.8 351.083 219.556 355.352 212.125ZM426.939 130.342C443.912 155.197 422.935 188.311 403.959 204.862C380.324 225.477 346.968 198.157 371.496 178.068C381.283 169.913 391.25 174.492 402.044 171.568C408.042 169.605 409.905 162.159 414.348 157.98C417.549 154.968 425.577 152.681 426.64 148.411C427.815 143.68 421.827 132.654 426.939 130.342ZM396.488 126.612C391.839 132.189 388.346 140.788 390.674 150.548C389.508 172.626 372.477 161.471 363.008 176.344C359.753 181.457 363.474 156.126 373.702 144.042C383.931 131.957 391.141 126.612 396.488 126.612Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 121.759,
    width: 125.219,
    y: 306.168,
    x: 201.898,
    id: "filter0_i_37_875"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    type: "matrix",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -5,
    dx: -19
  }), /*#__PURE__*/React.createElement("feComposite", {
    k3: 1,
    k2: -1,
    operator: "arithmetic",
    in2: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0",
    type: "matrix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "effect1_innerShadow_37_875",
    in2: "shape",
    mode: "normal"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 115.334,
    width: 92.3594,
    y: 303.049,
    x: 112.391,
    id: "filter1_i_37_875"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    type: "matrix",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -13,
    dx: 13
  }), /*#__PURE__*/React.createElement("feComposite", {
    k3: 1,
    k2: -1,
    operator: "arithmetic",
    in2: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.77 0",
    type: "matrix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "effect1_innerShadow_37_875",
    in2: "shape",
    mode: "normal"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 28.3809,
    width: 50.0977,
    y: 402.146,
    x: 303.055,
    id: "filter2_i_37_875"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    type: "matrix",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13
  }), /*#__PURE__*/React.createElement("feComposite", {
    k3: 1,
    k2: -1,
    operator: "arithmetic",
    in2: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0",
    type: "matrix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "effect1_innerShadow_37_875",
    in2: "shape",
    mode: "normal"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 137.374,
    width: 107.184,
    y: 126.612,
    x: 326,
    id: "filter3_i_37_875"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    type: "matrix",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9,
    dx: 11
  }), /*#__PURE__*/React.createElement("feComposite", {
    k3: 1,
    k2: -1,
    operator: "arithmetic",
    in2: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.36 0",
    type: "matrix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "effect1_innerShadow_37_875",
    in2: "shape",
    mode: "normal"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNanoclaw);
export default __webpack_public_path__ + "static/media/nanoclaw.afef70c30056d35f1e1ac5ced8d67fa6.svg";
export { ForwardRef as ReactComponent };